import { Switch as MuiSwitch } from "@mui/material";
import withStyles from '@mui/styles/withStyles';

export const Switch = withStyles((theme) => ({
  root: {
    width: 28,
    height: 14,
    padding: 0,
    display: "flex",
    overflow: "visible",
    margin: "0 7px",
  },
  switchBase: {
    padding: 2,
    color: theme.palette.grey[500],
    "&:focus-within + $track": {
      opacity: 1,
      border: "1px solid #000000",
    },
    "&$checked": {
      transform: "translateX(12px)",
      color: theme.palette.primary.main,
      "& + $track": {
        opacity: 1,
        backgroundColor: theme.palette.common.white,
        borderColor: theme.palette.primary.main,
      },
    },
  },
  thumb: {
    width: 12,
    height: 12,
    boxShadow: "none",
  },
  track: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: theme.palette.common.white,
  },
  checked: {},
}))(MuiSwitch);
